module.exports = __webpack_public_path__ + "img/icon-input-search.9ea8df9e.svg";